var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNegotiationFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.72223C11.0019 6.45549 10.8306 7.17883 10.5 7.83334C10.108 8.61764 9.5054 9.27732 8.75968 9.73849C8.01396 10.1997 7.15457 10.4441 6.27777 10.4444C5.54451 10.4464 4.82117 10.275 4.16666 9.94445L1 11L2.05555 7.83334C1.72496 7.17883 1.55364 6.45549 1.55555 5.72223C1.55589 4.84543 1.80034 3.98604 2.26151 3.24032C2.72268 2.4946 3.38236 1.892 4.16666 1.50002C4.82117 1.16942 5.54451 0.998104 6.27777 1.00002H6.55555C7.71352 1.0639 8.80723 1.55266 9.62729 2.37271C10.4473 3.19277 10.9361 4.28648 11 5.44445V5.72223Z",
    stroke: "#333541",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegotiationFull);
export default __webpack_public_path__ + "static/media/negotiationFull.84b03d7ab5577ff1d66b8a1bc2bf4aec.svg";
export { ForwardRef as ReactComponent };